export const APP_ENVIRONMENT = process.env.REACT_APP_ENV
export const API_BASE_URL = process.env.REACT_APP_BASE_API_URL
export const API_V2 = 'v2'
export const LANDING_PAGE_URL = process.env.REACT_APP_LANDING_PAGE 
export const NODE_ENVIRONMENT = process.env.NODE_ENV

export const USER_ROLES = {
  ADMIN: 'admin',
  COMPANY: 'company',
  RESOLVER: 'resolver',
  EVALUATOR: 'evaluator'
}

export const USER_FEATURES = {
  CHALLENGE: 'challenge',
  EVALUATION: 'evaluation',
  IDEA: 'idea',
  ADMIN_CITY_HALL: 'admin city hall',
  CITY_HALL: 'city hall'
}

export const USER_TERMS_TYPE = {
  USER: 'user',
  COMPANY: 'company',
  RESOLVER: 'resolver',
  EVALUATOR: 'evaluator'
}

export const ECOSYSTEM_TABS = {
  STARTUPS: 'Startups',
  INVESTORS: 'Investidores',
  COMPANY: 'Empresa',
  EVALUATORS: 'Avaliadores'
}

export const SOLUTION_STATUS = {
  APPROVED: 'Approved',
  DISAPPROVED: 'Archived',
  CREATED: 'Created',
  LAUNCHED: 'Launched',
  REJECTED: 'Rejected'
}

export const EVALUATOR_INVITE_STATUS = {
  INVITED: 'invited',
  ACCEPTED: 'accepted',
  REFUSED: 'rejected',
  CANCELED: 'canceled'
}

export const COMPANY_EVALUATION_INVITE_STATUS = {
  ACCEPTED: 'accepted',
  INVITED: 'invited',
  ERROR: 'error',
  REFUSED: 'rejected',
  EXPIRED: 'expired',
  CANCELED: 'canceled'
}

export const EVALUATION_STATUS = {
  CREATED: 'created',
  PENDING: 'pending',
  EVALUATED: 'evaluated',
  NOT_ACCEPTED: 'not accepted',
  CANCELED: 'canceled'
}

export const ROUTES = {
  NOT_FOUND: '*',
  HOTSITE: {
    ROOT: '/',
    MARKETPLACE: '/marketplace',
    EVENTS_PAGE: '/events',
    REGISTER: {
      EVALUATOR: '/register/evaluator/:challengeId',
      RESOLVER: '/register/resolver',
      SIMPLIFIED_RESOLVER: '/register/simplified-resolver', 
      RESOLVER_CONNECTION: '/register/resolver/:companyId',
      NATURAL_PERSON: '/register/natural-person',
      PUBLIC_ORGAN_MEMBER: '/register/public-organ-member/:cityHallId',
      PUBLIC_ADMINISTRATION: '/register/public-administration',
      CAIXA_EMPLOYEE: '/register/caixa-employee',
    },
    CONTACT: '/contact',
    CHALLENGE: '/challenge/:challengeId',
    EVENT: '/event/:eventId',
    INNOVATION_MAP: '/mapadainovacao',
    RESERVATION: '/reservation',
    MEETING_ROOM_RESERVATION: '/meeting-room-reservation',
  },
  USER_AUTH: {
    LOGIN: '/login',
    FORGOT_PASSWORD: '/forgot-password',
    RESET_PASSWORD: '/user/reset/:userId/:token'
  },
  HUB: {
    ROOT: '/hub',
    DASHBOARD: '/dashboard',
    USER_CONFIG: '/user-config',
    COMPANY: {
      CHALLENGE_LIST: '/company/challenge',
      CALENDAR: '/company/calendar',
      CHALLENGE_TEMPLATE: '/company/challenge/template',
      NEW_CHALLENGE: '/company/challenge/template/new',
      REFACTORY_NEW_CHALLENGE: '/company/challenge/novo',
      REFACTORY_NEW_CHALLENGE_EDIT: '/company/challenge/new/:challengeId/edit',
      EDIT_CHALLENGE: '/company/challenge/:challengeId/edit',
      GET_CHALLENGE: '/company/challenge/:challengeId',
      CHALLENGE_EVALUATORS: '/company/challenge/:challengeId/evaluators',
      CHALLENGE_SOLUTIONS: '/company/challenge/:challengeId/solutions',
      CHALLENGE_SOLUTIONS_SUBSCRIPTIONS: '/company/challenge/:challengeId/solutions/:solutionId/subscription',
      EVENTS_LIST: '/company/event',
      NEW_EVENT: '/company/event/new',
      EDIT_EVENT: '/company/event/:eventId/edit',
      GET_EVENT: '/company/event/:eventId',
      SCOUTING_LIST: '/company/scouting',
      NEW_SCOUTING: '/company/scouting/new',
      EDIT_SCOUTING: '/company/scouting/:scoutingId/edit',
      GET_SCOUTING: '/company/scouting/:scoutingId',
      SCOUTING_STARTUP: '/company/scouting/startup/:startupId',
      ECOSYSTEM: '/company/ecosystem',
      ECOSYSTEM_STARTUP: '/company/ecosystem/:companyId',
      ECOSYSTEM_PUBLIC_ADMINISTRATION: '/company/ecosystem/public-administration/:publicAdministrationId',
      PUBLIC_ORGANS: '/company/public-organs',
      CITY_HALL_MEMBERS: '/company/city-hall-members',
      CITY_HALL_MAIN: '/company/city-hall-main',
      MEETING_ROOM_SETTINGS: '/company/meeting-room/settings',
      MEETING_ROOM_MANAGE: '/company/meeting-room/manage-meeting-room',
      MEETING_ROOM_NEW: '/company/meeting-room/manage-meeting-room/new',
      MEETING_ROOM_DETAIL: '/company/meeting-room/manage-meeting-room/:meetingRoomId',
      MEETING_ROOM_EDIT: '/company/meeting-room/manage-meeting-room/:meetingRoomId/edit',
      MEETING_ROOM_RESERVED: '/company/meeting-room/meeting-room-reservation',
      MEETING_ROOM_REQUESTS: '/company/meeting-room/meeting-room-solicitation'
    },
    STARTUP: {
      CHALLENGE_LIST: '/startup/challenge',
      EVENTS_LIST: '/startup/event',
      GET_EVENT: '/startup/event/:eventId',
      GET_CHALLENGE: '/startup/challenge/:challengeId',
      APPLY_CHALLENGE: '/startup/challenge/:challengeId/apply',
      IDEA_LIST: '/startup/idea',
      GET_IDEA: '/startup/idea/:ideaId',
      EDIT_IDEA: '/startup/idea/:ideaId/challenge/:challengeId'
    },
    EVALUATOR: {
      CHALLENGE_LIST: '/evaluator/challenge',
      GET_CHALLENGE: '/evaluator/challenge/:challengeId',
      CHALLENGE_SOLUTIONS: '/evaluator/challenge/:challengeId/steps/:stepId/solutions',
      EVALUATE_IDEA: '/evaluator/challenge/:challengeId/step/:stepId/idea/:ideaId',
      INVITES: '/evaluator/invites'
    },
    TRACK: {
      TRACKS_LIST: '/tracks',
      TRACKS_CREATE: '/tracks/create',
      TRACKS_EDIT: '/tracks/:trackId/edit',
      TRACKS_AVAILABLE: '/available-tracks',
      TRACKS_AVAILABLE_DETAILS: '/available-tracks/details/:trackId',
      TRACKS_AVAILABLE_LESSON: '/available-tracks/details/lesson/:lessonId',
      TRACKS_GET: '/tracks/:trackId',
      LEARNING: '/learning',
      LEARNING_LESSON: '/learning/lesson/:lessonId'
    }
  }
}

export const INPUT_MASK_FORMAT = {
  CEP: '00000-000',
  PHONE: '(00) 0000-0000',
  MOBILE: '(00) 00000-0000',
  CPF: '000.000.000-00',
  CNPJ: '00.000.000/0000-00',
  DATE: '00/00/0000' 
}

export const getPhoneMask = (value: string): string => {
  if (typeof value !== 'string' || value.length === 0) return INPUT_MASK_FORMAT.PHONE

  const digitsOnly = value.replace(/\D/g, '')

  if (digitsOnly.length >= 11) {
    return INPUT_MASK_FORMAT.MOBILE
  } else if (digitsOnly.length >= 3) {
    const firstDigitAfterDDD = digitsOnly.charAt(2)
    if (firstDigitAfterDDD === '9') {
      return INPUT_MASK_FORMAT.MOBILE
    }
  }

  return INPUT_MASK_FORMAT.PHONE
}

export const DROPDOWN_COUNTRIES = [
  { value: '', label: 'Selecione' },
  { value: 'AF', label: 'Afeganistão' },
  { value: 'ZA', label: 'África do Sul' },
  { value: 'AL', label: 'Albânia' },
  { value: 'DE', label: 'Alemanha' },
  { value: 'AD', label: 'Andorra' },
  { value: 'AO', label: 'Angola' },
  { value: 'SA', label: 'Arábia Saudita' },
  { value: 'AR', label: 'Argentina' },
  { value: 'AM', label: 'Armênia' },
  { value: 'AU', label: 'Austrália' },
  { value: 'AT', label: 'Áustria' },
  { value: 'AZ', label: 'Azerbaijão' },
  { value: 'BS', label: 'Bahamas' },
  { value: 'BD', label: 'Bangladesh' },
  { value: 'BB', label: 'Barbados' },
  { value: 'BH', label: 'Bahrein' },
  { value: 'BY', label: 'Bielorrússia' },
  { value: 'BE', label: 'Bélgica' },
  { value: 'BZ', label: 'Belize' },
  { value: 'BJ', label: 'Benim' },
  { value: 'BO', label: 'Bolívia' },
  { value: 'BR', label: 'Brasil' },
  { value: 'BG', label: 'Bulgária' },
  { value: 'CA', label: 'Canadá' },
  { value: 'CL', label: 'Chile' },
  { value: 'CN', label: 'China' },
  { value: 'CO', label: 'Colômbia' },
  { value: 'KP', label: 'Coreia do Norte' },
  { value: 'KR', label: 'Coreia do Sul' },
  { value: 'CR', label: 'Costa Rica' },
  { value: 'CU', label: 'Cuba' },
  { value: 'DK', label: 'Dinamarca' },
  { value: 'EG', label: 'Egito' },
  { value: 'AE', label: 'Emirados Árabes Unidos' },
  { value: 'EC', label: 'Equador' },
  { value: 'ES', label: 'Espanha' },
  { value: 'US', label: 'Estados Unidos' },
  { value: 'FR', label: 'França' },
  { value: 'GR', label: 'Grécia' },
  { value: 'IN', label: 'Índia' },
  { value: 'ID', label: 'Indonésia' },
  { value: 'IT', label: 'Itália' },
  { value: 'JP', label: 'Japão' },
  { value: 'MX', label: 'México' },
  { value: 'NG', label: 'Nigéria' },
  { value: 'NL', label: 'Países Baixos' },
  { value: 'PT', label: 'Portugal' },
  { value: 'RU', label: 'Rússia' },
  { value: 'CH', label: 'Suíça' },
  { value: 'TR', label: 'Turquia' },
  { value: 'UA', label: 'Ucrânia' },
  { value: 'GB', label: 'Reino Unido' },
  { value: 'VE', label: 'Venezuela' }
]

export const EVALUATOR_TYPES = [
  { value: '', label: 'Selecione' },
  { value: 'Professor/Docente', label: 'Professor/Docente' },
  { value: 'Técnico Especializado', label: 'Técnico Especializado' },
  { value: 'Outro', label: 'Outro' }
]
export const DROPDOWN_BRAZIL_STATES = [
  { value: '', label: 'Selecione' },
  { value: 'AC', label: 'AC' },
  { value: 'AP', label: 'AP' },
  { value: 'AL', label: 'AL' },
  { value: 'AM', label: 'AM' },
  { value: 'BA', label: 'BA' },
  { value: 'CE', label: 'CE' },
  { value: 'DF', label: 'DF' },
  { value: 'ES', label: 'ES' },
  { value: 'GO', label: 'GO' },
  { value: 'MA', label: 'MA' },
  { value: 'MT', label: 'MT' },
  { value: 'MS', label: 'MS' },
  { value: 'MG', label: 'MG' },
  { value: 'PA', label: 'PA' },
  { value: 'PB', label: 'PB' },
  { value: 'PR', label: 'PR' },
  { value: 'PE', label: 'PE' },
  { value: 'PI', label: 'PI' },
  { value: 'RJ', label: 'RJ' },
  { value: 'RN', label: 'RN' },
  { value: 'RS', label: 'RS' },
  { value: 'RO', label: 'RO' },
  { value: 'RR', label: 'RR' },
  { value: 'SC', label: 'SC' },
  { value: 'SP', label: 'SP' },
  { value: 'SE', label: 'SE' },
  { value: 'TO', label: 'TO' }
]

export const DROPDOWN_ACTIVITY = [
  { value: '', label: 'Selecione' },
  { value: 'AgTech', label: 'AgTech' },
  { value: 'BioTech', label: 'BioTech' },
  { value: 'Cibersegurança', label: 'Cibersegurança' },
  { value: 'Comunicação', label: 'Comunicação' },
  { value: 'DeepTech', label: 'DeepTech' },
  { value: 'EdTech', label: 'EdTech' },
  { value: 'EnergyTech', label: 'EnergyTech' },
  { value: 'ESG', label: 'ESG' },
  { value: 'FinTech', label: 'FinTech' },
  { value: 'FoodTech', label: 'FoodTech' },
  { value: 'GovTech', label: 'GovTech' },
  { value: 'GreenTech', label: 'GreenTech' },
  { value: 'Gestão de negócios e projetos', label: 'Gestão de negócios e projetos' },
  { value: 'HealthTech', label: 'HealthTech' },
  { value: 'HRTech', label: 'HRTech' },
  { value: 'Indústria', label: 'Indústria' },
  { value: 'InsurTech', label: 'InsurTech' },
  { value: 'MarTech', label: 'MarTech' },
  { value: 'Mídia e entretenimento', label: 'Mídia e entretenimento' },
  { value: 'Mobilidade', label: 'Mobilidade' },
  { value: 'PetTech', label: 'PetTech' },
  { value: 'Construtech', label: 'Construtech' },
  { value: 'RegTech', label: 'RegTech' },
  { value: 'RetailTech', label: 'RetailTech' },
  { value: 'SportTech', label: 'SportTech' },
  { value: 'Supply Chain', label: 'Supply Chain' },
  { value: 'TurisTech', label: 'TurisTech' },
  { value: 'LawTech', label: 'LawTech' },
  { value: 'Não registrado', label: 'Não registrado' }
]

export const DROPDOWN_BUSINESS_MODEL = [
  { value: '', label: 'Selecione' },
  { value: 'Advertising', label: 'Advertising' },
  { value: 'API', label: 'API' },
  { value: 'Consumer', label: 'Consumer' },
  { value: 'E-commerce', label: 'E-commerce' },
  { value: 'Hardware', label: 'Hardware' },
  { value: 'Licenciamento', label: 'Licenciamento' },
  { value: 'Marketplace', label: 'Marketplace' },
  { value: 'Pay-per-use', label: 'Pay-per-use' },
  { value: 'SaaS', label: 'SaaS' },
  { value: 'Subscription', label: 'Subscription' },
  { value: 'Transactional', label: 'Transactional' },
  { value: 'Venda de dados', label: 'Venda de dados' },
  { value: 'Não registrado', label: 'Não registrado' }
]

export const DROPDOWN_TARGET_MODEL = [
  { value: '', label: 'Selecione' },
  { value: 'B2B', label: 'Somente B2B' },
  { value: 'B2C', label: 'Somente B2C' },
  { value: 'B2G', label: 'Somente B2G' },
  { value: 'B2B e B2C', label: 'B2B e B2C' },
  { value: 'B2B e B2G', label: 'B2B e B2G' },
  { value: 'B2B, B2C e B2G', label: 'B2B, B2C e B2G' }
]

export const DROPDOWN_NUMBER_EMPLOYEES = [
  { value: '', label: 'Selecione' },
  { value: '0-1', label: '0-1 funcionários' },
  { value: '2-10', label: '2-10 funcionários' },
  { value: '11-50', label: '11-50 funcionários' },
  { value: '51-200', label: '51-200 funcionários' },
  { value: '200+', label: '200+ funcionários' }
]

export const DROPDOWN_TECHNOLOGIES = [
  { value: '', label: 'Selecione' },
  { value: 'JavaScript', label: 'JavaScript' },
  { value: 'TypeScript', label: 'TypeScript' },
  { value: 'Python', label: 'Python' },
  { value: 'Java', label: 'Java' },
  { value: 'C#', label: 'C#' },
  { value: 'PHP', label: 'PHP' },
  { value: 'Ruby', label: 'Ruby' },
  { value: 'Go', label: 'Go' },
  { value: 'Swift', label: 'Swift' },
  { value: 'Kotlin', label: 'Kotlin' },
  { value: 'Objective-C', label: 'Objective-C' },
  { value: 'C++', label: 'C++' },
  { value: 'C', label: 'C' },
  { value: 'Rust', label: 'Rust' },
  { value: 'Scala', label: 'Scala' },
  { value: 'Perl', label: 'Perl' },
  { value: 'R', label: 'R' },
  { value: 'Elixir', label: 'Elixir' },
  { value: 'Dart', label: 'Dart' },
  { value: 'Haskell', label: 'Haskell' },
  { value: 'MATLAB', label: 'MATLAB' },
  { value: 'Shell', label: 'Shell' },
  { value: 'PowerShell', label: 'PowerShell' },
  { value: 'HTML', label: 'HTML' },
  { value: 'CSS', label: 'CSS' },
  { value: 'Sass', label: 'Sass' },
  { value: 'Less', label: 'Less' },
  { value: 'SQL', label: 'SQL' },
  { value: 'NoSQL', label: 'NoSQL' },
  { value: 'GraphQL', label: 'GraphQL' },
  { value: 'React', label: 'React' },
  { value: 'Angular', label: 'Angular' },
  { value: 'Vue.js', label: 'Vue.js' },
  { value: 'Svelte', label: 'Svelte' },
  { value: 'Ember.js', label: 'Ember.js' },
  { value: 'Backbone.js', label: 'Backbone.js' },
  { value: 'jQuery', label: 'jQuery' },
  { value: 'ASP.NET', label: 'ASP.NET' },
  { value: 'Spring', label: 'Spring' },
  { value: 'Django', label: 'Django' },
  { value: 'Flask', label: 'Flask' },
  { value: 'Laravel', label: 'Laravel' },
  { value: 'Symfony', label: 'Symfony' },
  { value: 'Ruby on Rails', label: 'Ruby on Rails' },
  { value: 'Express', label: 'Express' },
  { value: 'NestJS', label: 'NestJS' },
  { value: 'Next.js', label: 'Next.js' },
  { value: 'Nuxt.js', label: 'Nuxt.js' },
  { value: 'Gatsby', label: 'Gatsby' },
  { value: 'Meteor', label: 'Meteor' },
  { value: 'Flutter', label: 'Flutter' },
  { value: 'React Native', label: 'React Native' },
  { value: 'Ionic', label: 'Ionic' },
  { value: 'Xamarin', label: 'Xamarin' },
  { value: 'Unity', label: 'Unity' },
  { value: 'Unreal Engine', label: 'Unreal Engine' }
]

export const DROPDOWN_DEVELOPMENT_STAGE = [
  { value: '', label: 'Selecione' },
  { value: '1', label: 'Ainda não realizei vendas do produto' },
  { value: '2', label: 'Já realizei a primeira venda' },
  { value: '3', label: 'Já tenho vendas recorrentes' }
]

export const RESOLVER_DROPDOWN_ROLES = [
  { value: '', label: 'Selecione' },
  { value: 'Sócio(a)/Fundador(a)', label: 'Sócio(a)/Fundador(a)' },
  { value: 'Presidente/Vice-Presidente', label: 'Presidente/Vice-Presidente' },
  { value: 'Diretor(a)', label: 'Diretor(a)' },
  { value: 'Coordenador(a)', label: 'Coordenador(a)' },
  { value: 'Analista', label: 'Analista' },
  { value: 'Técnico(a)', label: 'Técnico(a)' },
  { value: 'Assistente', label: 'Assistente' },
  { value: 'Estagiário(a)', label: 'Estagiário(a)' },
  { value: 'Estudante', label: 'Estudante' }
]

export const RESOLVER_INVESTMENTE_SOURCE = [
  { value: '', label: 'Selecione' },
  { value: 'Investidor-anjo', label: 'Investidor-anjo' },
  { value: 'Capital semente', label: 'Capital semente' },
  { value: 'Private equity', label: 'Private equity' },
  { value: 'Aceleradoras', label: 'Aceleradoras' },
  { value: 'Aceleradora', label: 'Aceleradora' },
  { value: 'Venture capital', label: 'Venture capital' },
  { value: 'Outro', label: 'Outro' }
]
export const NUMBER_OF_SUBSCRIBE_OPTIONS: any[] = [
  {
    id: 'once',
    value: '1',
    label: 'Apenas uma vez',
    isDeleted: false,
    path: ''
  },
  {
    id: 'twice',
    value: '2',
    label: 'Duas vezes',
    isDeleted: false,
    path: ''
  },
  {
    id: 'three',
    value: '3',
    label: 'Três vezes',
    isDeleted: false,
    path: ''
  },
  {
    id: 'four',
    value: '4',
    label: 'Quatro vezes',
    isDeleted: false,
    path: ''
  },
  {
    id: 'five',
    value: '5',
    label: 'Cinco vezes',
    isDeleted: false,
    path: ''
  },
  {
    id: 'six',
    value: '6',
    label: 'Seis vezes',
    isDeleted: false,
    path: ''
  },
  {
    id: 'seven',
    value: '7',
    label: 'Sete vezes',
    isDeleted: false,
    path: ''
  },
  {
    id: 'eight',
    value: '8',
    label: 'Oito vezes',
    isDeleted: false,
    path: ''
  },
  {
    id: 'nine',
    value: '9',
    label: 'Nove vezes',
    isDeleted: false,
    path: ''
  },
  {
    id: 'ten',
    value: '1000',
    label: 'Infinitas vezes',
    isDeleted: false,
    path: ''
  }

]

export const SCOUTING_VERTICAL_SECTOR = [
  { value: '', label: 'Selecione' },
  { value: 'AgTech', label: 'AgTech' },
  { value: 'BioTech', label: 'BioTech' },
  { value: 'Cibersegurança', label: 'Cibersegurança' },
  { value: 'Comunicação', label: 'Comunicação' },
  { value: 'DeepTech', label: 'DeepTech' },
  { value: 'EdTech', label: 'EdTech' },
  { value: 'EnergyTech', label: 'EnergyTech' },
  { value: 'ESG', label: 'ESG' },
  { value: 'FinTech', label: 'FinTech' },
  { value: 'FoodTech', label: 'FoodTech' },
  { value: 'GovTech', label: 'GovTech' },
  { value: 'GreenTech', label: 'GreenTech' },
  { value: 'HealthTech', label: 'HealthTech' },
  { value: 'HRTech', label: 'HRTech' },
  { value: 'Indústria', label: 'Indústria' },
  { value: 'InsurTech', label: 'InsurTech' },
  { value: 'MarTech', label: 'MarTech' },
  { value: 'Mobilidade', label: 'Mobilidade' },
  { value: 'RegTech', label: 'RegTech' },
  { value: 'RetailTech', label: 'RetailTech' },
  { value: 'SportTech', label: 'SportTech' },
  { value: 'TurisTech', label: 'TurisTech' },
  { value: 'LawTech', label: 'LawTech' }
]

export const SCOUTING_TARGET_AUDIENCE = [
  { value: '', label: 'Selecione' },
  { value: 'B2B', label: 'Somente B2B' },
  { value: 'B2C', label: 'Somente B2C' },
  { value: 'B2G', label: 'Somente B2G' },
  { value: 'B2B e B2C', label: 'B2B e B2C' },
  { value: 'B2B e B2G', label: 'B2B e B2G' },
  { value: 'B2B, B2C e B2G', label: 'B2B, B2C e B2G' }
]

export const SCOUTING_BUSINESS_MODEL = [
  { value: '', label: 'Selecione' },
  { value: 'Advertising', label: 'Advertising' },
  { value: 'API', label: 'API' },
  { value: 'Consumer', label: 'Consumer' },
  { value: 'E-commerce', label: 'E-commerce' },
  { value: 'Hardware', label: 'Hardware' },
  { value: 'Licenciamento', label: 'Licenciamento' },
  { value: 'Marketplace', label: 'Marketplace' },
  { value: 'Pay-per-use', label: 'Pay-per-use' },
  { value: 'SaaS', label: 'SaaS' },
  { value: 'Subscription', label: 'Subscription' },
  { value: 'Transactional', label: 'Transactional' },
  { value: 'Venda de dados', label: 'Venda de dados' }
]

export const SCOUTING_DEVELOPMENT_STAGE = [
  { value: '', label: 'Selecione' },
  { value: 'Ideação', label: 'Ideação' },
  { value: 'MVP', label: 'MVP (Produto Mínimo Viável)' },
  { value: 'Primeira Venda', label: 'Primeira Venda' },
  { value: 'Vendas Recorrentes', label: 'Vendas Recorrentes' },
  { value: 'Escala', label: 'Escala' },
  { value: 'Expansão', label: 'Expansão' }
]
